import apiClient from "../common/apiClient.js";

export default class TenantController {
  async Create(data, token) {
    try {
      return await apiClient.post("/register", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
}
